/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Checkmark from '../../icons/checkmark.svg';

import { CheckBoxWrapper, CheckBoxLabel, CheckBox } from './common';
import FormError from './common/FormError';
import Required from './common/Required';

const CheckBoxInput = (props) => {
  const { field, label, value, required, form } = props;
  const { touched, errors } = form;
  const { name } = field;
  const error = errors[name];
  const touch = touched[name];

  return (
    <>
      <CheckBoxWrapper name={name}>
        <CheckBox type="checkbox" {...field} value={value} id={name} />
        <span data-type="checkbox">
          <Checkmark />
        </span>
        <CheckBoxLabel>
          {label} <Required required={required} />
          <FormError touch={touch} error={error} />
        </CheckBoxLabel>
      </CheckBoxWrapper>
    </>
  );
};

export default CheckBoxInput;
